import { Directive, ElementRef, Renderer2 } from '@angular/core';
import { ThemeService } from '../services/theme.service';

@Directive({
  selector: '[appTitleBar]'
})
export class TitleBarDirective {
  siteProperties: any;
  baseUrl: string;
  themeListTitleBar: any;

  constructor(public el: ElementRef, public renderer: Renderer2, private themeService: ThemeService) {
    themeService.getBaseUrl().once('value', snapshot => {
      this.siteProperties = [];
      snapshot.forEach(snap => {
        if (snap.val().state === '1') {
          this.siteProperties.push({
            baseUrl: snap.val().base_url
          });
        }
      });
      this.baseUrl = this.siteProperties[0].baseUrl;
    });

    this.themeService.getThemeList().once('value', snapshot => {
      this.themeListTitleBar = [];
      snapshot.forEach(snap => {
        if (snap.val().state === '1') {
          this.themeListTitleBar.push({
            titleBarBackgroundColor: snap.val().title_bar_background_color,
            titleBarFontColor: snap.val().title_bar_font_color
          });
        }
      });


      
      this.renderer.setAttribute(el.nativeElement, 'style', '--background: ' + this.themeListTitleBar[0].titleBarBackgroundColor + '; --color: ' + this.themeListTitleBar[0].titleBarFontColor);
      // this.renderer.setAttribute(el.nativeElement, 'style', '--color: ' + this.themeList[0].titleBarFontColor);
    });
  }

}
